import { createFileRoute } from "@tanstack/react-router";
import ProgramCreate from "../../../../../views/programs/ProgramCreate";

export const Route = createFileRoute("/_authenticated/user/advertising/programs/create")({
  component: ProgramCreate,
});
